/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/class-name-casing */
import { makeAutoObservable, configure } from "mobx";
import request, { requestApi } from "./utils/request";
import lvieRequest from "./utils/liveRequest";
import MaskPopup from "./components/Mask";
import { Toast } from "antd-mobile";
import {
  isWeiBo,
  isWeiXinAndQQ,
  isWeiXin,
  isAndroid,
  jumpHandle,
} from "./utils/utils";
import trim from "lodash/trim";
import UM from "./utils/UM";
import { debounce, method, times } from "lodash";
import { getLogo } from "./utils/baseInfo";
import {
  getAcId,
  getSearchFoundHideFlag,
  removeSearchFoundHideFlag,
  setSearchFoundHideFlag,
} from "./store/UserStore";
import { storeHistory } from "./store/HistoryStore";
import NProgress from "nprogress";
import { route } from "preact-router";
import TokenPopup from "./routes/details/component/DetailPop";
import SignPop from "./routes/signin/component/SignPop";
import axios from "axios";
import { filterSearchResultList } from "./utils/searchResultList";
NProgress.configure({ showSpinner: false, easing: "ease", speed: 200 });

export const FROM_SCENE = {
  HOTWORDS: "hotwords",
  HISTORY: "history",
  INPUT: "input",
  RECOMMEND: "home_recommend",
  RELATION: "relation",
  SHARE: "share",
  COLLECT: "collect",
  INFORMATION: "information",
  BROWSE: "browse",
  SEARCHFOUND: "searchfound",
  VISIT: "visit",
  REDANDBLACKLIST: "redandblacklist",
  HOTSELLERLIST: "hotsellerlist",
  GIFTLIST: "giftlist",
  EXTENSION: "extension",
};
configure({
  enforceActions: "never",
});
class store {
  constructor() {
    makeAutoObservable(this);
  }
  //首页数据
  historyBackFlag = false;
  indexScrollY = 0;
  middleScrollY = 0;
  productDetail: any = {};
  backFlag = false;
  BackIndex = () => {
    if (this.backFlag) {
      window.history.back();
    } else {
      const search = new URLSearchParams(window.location.search);
      window.location.replace(`/?${search.toString()}`);
    }
    UM({ page: "搜索", event: "返回" });
  };
  //跳转详情页
  hasPageListFlag = false;
  handleJump = async (item: any) => {
    this.currentPage = 98;
    this.historyBackFlag = true;
    this.productDetail = { ...item };
    const params = new URLSearchParams(window.location.search);
    if (params.has("itemId")) {
      params.delete("itemId");
    }
    if (params.get("couponId")) {
      params.delete("couponId");
    }
    if (item.itemId) {
      params.set("itemId", item.itemId);
    }
    if (item.couponId) {
      params.set("couponId", item.couponId);
    }
    params.set("platform", item.platform);
    route(`/detail?${params.toString()}`);
    this.hasPageListFlag = true;
    window.scrollTo(0, 0);
    this.getProductDetail();
  };
  //获取商品详情
  bloggerInfo: any = {};
  userDetail: any = {};
  getProductDetail = async () => {
    const params = new URLSearchParams(window.location.search);
    let couponId: any = this.productDetail?.couponId,
      itemId: any = this.productDetail?.itemId,
      platform: any = this.productDetail?.platform;
    if (Object.keys(this.productDetail).length === 0) {
      itemId = params.get("itemId");
      couponId = params.get("couponId");
      platform = params.get("platform");
      if (!itemId) {
        window.location.replace("/");
        return;
      }
    }
    const { data, err }: any = await request("/search/details", {
      method: "POST",
      data: {
        itemId: itemId,
        couponId: couponId,
        platform,
      },
      header: {
        webData: `from=${this.productDetail.sortFrom || FROM_SCENE.SHARE}&loc=${this.productDetail.sortIndex || 0}`,
      },
    });
    if (err) return;
    const detailData = data?.data;
    if (
      !detailData ||
      Object.keys(detailData).length === 0 ||
      detailData.itemId === "" ||
      detailData.itemId === 0
    ) {
      return;
    }
    UM({
      page: "详情",
      label: "浏览商品",
      value: this.productDetail.itemId,
      from: this.productDetail.detailFrom || FROM_SCENE.SHARE,
      loc: this.productDetail.sortIndex || "0",
      rFrom: this.productDetail.sortFrom || FROM_SCENE.SHARE,
      rLoc: this.productDetail.sortIndex || "0",
    });
    if (this.productDetail.mainPic) {
      detailData.mainPic = this.productDetail.mainPic;
    }
    this.productDetail = Object.assign(this.productDetail, detailData);
    this.bloggerInfo = detailData.bloggerInfo;
    this.userDetail = detailData.productDetailWbInfoDto;
    document.title = detailData.title;
  };
  //转链
  transformLinkLoading = false;
  transformLink = async (p: number) => {
    if (this.transformLinkLoading) return;
    this.transformLinkLoading = true;
    NProgress.set(0.6);
    const params = new URLSearchParams(window.location.search);
    const labelData = () => {
      if (p == 1) {
        return "领券";
      } else if (p == 2) {
        return "到手价";
      } else if (p == 3) {
        return "搜索快捷方式";
      } else if (p == 4) {
        return "逛逛社区";
      } else if (p == 5) {
        return "直播预告";
      } else {
        return "领券";
      }
    };
    UM({
      page: "购买",
      label: labelData(),
      value: this.productDetail.numId || "",
      title: this.productDetail.title || "",
      commission: `${this.productDetail.commission}` || "",
      keywords: this.keywords || "",
      from: this.detailFrom,
      loc: p,
      rFrom: this.productDetail.sortFrom || FROM_SCENE.SHARE,
      rLoc: this.productDetail.sortIndex || "0",
    });
    let nowdata: any = {
      itemId: this.productDetail.itemId || params.get("itemId"),
      couponId: this.productDetail.couponId || params.get("couponId"),
      platform: this.productDetail.platform || params.get("platform"),
    };
    const lastUrl = `/product/transformLink`;
    if (params.get("scence") === "landing") {
      nowdata.scene = "landing";
    }
    if (this.productDetail.bloggerFlag) {
      nowdata.scene = "blogger";
    }
    //注销淘宝授权
    // if (this.autoBind && !this.tb_bind&&(p==1||p==2)) {
    //   nowdata.isTbBind = true;
    // }
    if (p == 4) {
      nowdata.businessscenario = "community";
    }
    const { data, err }: any = await request(lastUrl, {
      method: "POST",
      data: nowdata,
    });
    this.transformLinkLoading = false;
    if (err) return;
    if (isWeiXinAndQQ() && this.productDetail.platform == "tb") {
      //微信和QQ淘宝品口令购买
      TokenPopup.showToken(1, data.data.token);
      NProgress.set(1);
      return;
    }
    if (isWeiBo()) {
      let visible = true;
      let timeout: any = null;
      let startTime = 0;
      const handle = () => {
        if (document.visibilityState === "hidden") {
          startTime = new Date().getTime();
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          visible = false;
        }
        if (document.visibilityState === "visible") {
          document.removeEventListener("visibilitychange", handle);
          if (new Date().getTime() - startTime < 300 && isAndroid()) {
            window.location.href = data.data.link;
          }
          visible = false;
        }
      };
      document.addEventListener("visibilitychange", handle);
      const iframe: any = document.createElement("iframe");
      iframe.style.visibility = "hidden";
      iframe.style.width = 0;
      iframe.style.height = 0;
      iframe.src = data.data.urlScheme;
      iframe.onerror = () => (window.location.href = data.data.link);
      document.body.appendChild(iframe);
      timeout = setTimeout(() => {
        if (visible) window.location.href = data.data.link;
      }, 2000);
      setTimeout(() => {
        NProgress.set(1);
      }, 2000);
      return;
    }
    NProgress.set(1);
    window.location.href = data.data.link;
  };
  //微信小程序跳转
  jumpWx = async (itemUrl: any) => {
    const url = new URL(itemUrl);
    const Param: any = new URLSearchParams(url.searchParams);
    UM({
      page: "购买",
      label: "群接龙",
      value: this.productDetail.itemId,
      from: "minApp",
      loc: 1,
      rFrom: "群接龙",
      rLoc: 0,
    });
    if (isWeiBo()) {
      const ghName = Param.get("ghName") || "gh_1bbc95f9877e";
      const miniFullPath = encodeURIComponent("/" + Param.get("miniFullPath"));
      window.location.href = `sinaweibo://wbdiversion?username=${ghName}&path=${miniFullPath}`;
    } else {
      const appId = Param.get("appId") || "wx974b793334f3667b";
      const miniFullPath = decodeURIComponent(Param.get("miniFullPath"));
      if (miniFullPath.includes("pages/breadcrumb")) {
        window.location.href =
          "https://fd.tmallgenie.com/pages/shop.html#/activity?page=214";
        return;
      }
      const miniPath = miniFullPath.split("?")[0];
      const query = miniFullPath.split("?")[1];
      const newQuery = query
        .split("&")
        .map((keyValue) => {
          const keyValueList = keyValue.split("=");
          const key = keyValueList[0];
          const value = keyValueList[1];
          return key + "=" + encodeURIComponent(value);
        })
        .join("&");
      const res = await requestApi({
        url: "/wxa-link/gen_url_scheme",
        method: "POST",
        data: {
          appId,
          expireType: 1,
          expireInterval: 30,
          jumpWxa: {
            path: miniPath,
            query: newQuery,
          },
        },
      });
      window.location.href = res.data.openLink;
    }
  };
  getShortUrl = async () => {
    NProgress.set(0.6);
    const { data, err }: any = await request(`/common/shortUrl`, {
      method: "POST",
      data: { url: window.location.href },
    });
    NProgress.set(1);
    if (err) return;
    TokenPopup.showToken(2, data.data);
  };

  bigPhone = (function judgeBigScreen() {
    //，这里根据返回值 true 或false ,返回true的话 则为全面屏
    let result = false;
    const u = navigator.userAgent;
    if (u.indexOf("iPhone") == -1) {
      return false;
    }
    const rate = window.screen.height / window.screen.width;
    let limit = window.screen.height == window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
    if (rate > limit) {
      result = true;
    }
    return result;
  })();
  //搜素数据
  detailFrom = FROM_SCENE.SHARE;
  mode = "default";
  foncusFlag = false;
  keywords = "";
  paste = "";
  loading = false;
  searchParams: any = 1;
  hasCoupon = true;
  platformParams = "";
  participleText = "";
  participleList = [];
  productList: any = [];
  onBlur = () => {
    this.foncusFlag = false;
  };
  commontReset = () => {
    this.mode = "default";
    this.keywords = "";
    this.participleText = "";
    this.participleList = [];
    this.productList = [];
    this.platformParams = "";
    this.searchParams = 1;
    this.hasCoupon = true;
    this.searchVisitList = {};
    this.searchVisitKeywords = "";
    const search = new URLSearchParams(window.location.search);
    search.delete("keywords");
    search.delete("sort");
    window.history.replaceState(null, "", `?${search}`);
  };
  commontResetTwo = () => {
    this.participleText = "";
    this.participleList = [];
    this.productList = [];
  };
  onFocus = async () => {
    this.foncusFlag = true;
    this.backFlag = true;
    this.mode = "input";
    this.searchVisitList = {};
    this.searchVisitKeywords = "";
    this.commontResetTwo();
    if (this.currentPage == 1 || this.currentPage == 2) {
      this.currentPage = 99;
      const params = new URLSearchParams(window.location.search);
      route(`/middle?${params.toString()}`);
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  };
  handelItem = (words: any, type: any) => {
    if (type == 1) {
      this.detailFrom = FROM_SCENE.INPUT;
    } else if (type == 2) {
      this.detailFrom = FROM_SCENE.HISTORY;
    } else if (type == 3) {
      this.detailFrom = FROM_SCENE.SEARCHFOUND;
    } else {
      this.detailFrom = FROM_SCENE.INPUT;
    }
    this.commontResetTwo();
    this.keywords = words;
    this.getProductList();
  };
  goodsInfoList: any = [];
  suggestionList: any = [];
  getSuggestion = debounce(async () => {
    if (!this.keywords) {
      this.suggestionList = [];
      this.goodsInfoList = [];
      return;
    }
    const { data, err }: any = await request(
      `/search/suggestion?text=${this.keywords}`,
      { method: "GET" },
    );
    if (err) {
      return;
    }
    this.suggestionList = data.data.suggestion || [];
    this.goodsInfoList = data.data.goodsInfoList || [];
  }, 500);
  searchInputTextChange = async (e: any) => {
    const text = trim(e.target.value);
    this.keywords = text;
    if (!text || text.length === 0) {
      this.keywords = "";
      const searchObj: any = document.getElementById("search-input-id-all");
      searchObj.value = "";
    }
    this.getSuggestion();
  };
  //切换筛选条件
  handleFilter = (filter: any) => {
    if (filter.type == 1) {
      if (this.platformParams && this.platformParams == filter.value) {
        this.platformParams = "";
        this.hasCoupon = true;
      } else {
        if (filter.value == "tb" || filter.value == "tmcs") {
          this.hasCoupon = true;
        } else {
          this.hasCoupon = false;
        }
        this.platformParams = filter.value;
      }
    } else if (filter.type == 2) {
      if (filter.value == 34) {
        if (this.searchParams == 4) {
          this.searchParams = 3;
        } else {
          this.searchParams = 4;
        }
      } else if (filter.value != this.searchParams) {
        this.searchParams = filter.value;
      } else {
        return;
      }
    } else if (filter.type == 3) {
      this.hasCoupon = !this.hasCoupon;
    }
    this.commontResetTwo();
    this.getProductList();
  };
  //搜索发现
  initSearchData = async () => {
    const searchFoundHideFlag = await getSearchFoundHideFlag();
    if (searchFoundHideFlag == "hide") {
      this.searchFoundHideFlag = true;
    } else {
      this.getSearchFound();
      this.searchFoundHideFlag = false;
    }
  };
  searchFoundHideFlag = false;
  searchFound: any = [];
  getSearchFound = async () => {
    const { data, err }: any = await request(`/search/found`, {
      method: "GET",
    });
    if (err) return;
    this.searchFound = data.data;
  };
  handleSearchFoundHideFlag = () => {
    if (this.searchFoundHideFlag == true) {
      this.searchFoundHideFlag = false;
      removeSearchFoundHideFlag();
      if (this.searchFound.length == 0) {
        this.getSearchFound();
      }
    } else {
      this.searchFoundHideFlag = true;
      setSearchFoundHideFlag("hide");
    }
  };
  //搜索接口
  productListLoading = false;
  getProductList = async ({ words = "" } = {}) => {
    if (!words && this.keywords.length === 0) return;
    if (words) this.keywords = words;
    this.mode = "search";
    this.productListLoading = true;
    if (this.goodsInfoList.length > 0) {
      storeHistory(this.goodsInfoList[0]?.title);
    } else {
      storeHistory(words || this.keywords);
    }
    if (this.paste === this.keywords) {
      UM({
        page: "搜索",
        event: "粘贴文本",
        value: words || this.keywords,
        from: this.detailFrom,
      });
    } else {
      UM({
        page: "搜索",
        event: "输入关键字",
        value: words || this.keywords,
        from: this.detailFrom,
      });
    }
    const searchParamsData: any = {
      all_default: 1,
      total_sales_des: 2,
      price_asc: 3,
      price_des: 4,
    };
    if (this.keywords == "天猫超市") {
      this.platformParams = "tmcs";
    }
    const { data, err }: any = await request(`/search`, {
      method: "POST",
      data: {
        text: words || this.keywords,
        sort: this.searchParams,
        hasCoupon: this.hasCoupon ? 1 : 0,
        type: this.platformParams,
      },
      header: { webData: `from=${this.detailFrom}` },
    });
    this.productListLoading = false;
    if (err) {
      return;
    }
    const search = new URLSearchParams(window.location.search);
    search.set("keywords", words || this.keywords);
    search.set("sort", this.searchParams);
    window.history.replaceState(null, "", `?${search}`);
    if (data.data.participleText) {
      this.participleText = data.data.participleText;
      this.participleList = data.data.participleList;
      this.productList = filterSearchResultList(data.data.participleGoodsInfoList);
      this.platformParams = "";
      UM({ page: "搜索", event: "分词显示", value: this.keywords });
    } else {
      this.productList = filterSearchResultList(data.data.goodsInfoList);
      UM({
        page: "搜索",
        event: this.productList?.length > 0 ? "搜索结果正常" : "无搜索结果",
        value: this.keywords,
      });
    }
  };
  currentPage = 1;
  memberWhiteFlag = false;
  WeiBoCollectionInfo = {};
  WeiBoCollectionQueryCjsList = async () => {
    const search = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(`/home/config`, { method: "GET" });
    if (err) return;
    if (
      search.get("gh_id") == "5886285543" ||
      search.get("gh_id") == "6016394371"
    ) {
      data.data.nickName = data.data.bloggerNickName;
    }
    this.WeiBoCollectionInfo = data.data;
    if (
      data.data.isMembersArea &&
      !isWeiXinAndQQ() &&
      search.get("scence") != "landing"
    ) {
      this.memberWhiteFlag = true;
      this.GetWeixinMywebchatCheckUserSign();
      this.GetuserInfoIntegral();
      // const auto_div:any=document.getElementById("auto_div");
      // if(auto_div){
      //   auto_div.style.display="block";
      // }
    } else {
      this.memberWhiteFlag = false;
    }
  };
  //
  //获取用户信息，领取或者补充积分
  GetuserInfoIntegral = async () => {
    const acId = await getAcId();
    if (!acId) {
      return;
    }
    const { data, err }: any = await request(`/user/info`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
    this.userInfo = data.data;
    if (data.data.isGetIntegral === 0 || data.data.isGetIntegral === 1) {
      this.GetIntegralCompensate();
    }
  };
  //领取积分
  GetIntegralCompensate = async () => {
    const { data, err }: any = await request(`/integral/compensate`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
  };
  //淘宝自动授权开关
  autoBind = false;
  tb_bind = false;
  GetWeixinMywebchatCheckUserSign = async () => {
    if (this.tb_bind || !this.memberWhiteFlag) {
      return;
    }
    const acId = await getAcId();
    if (acId) {
      const { data, err }: any = await request(
        `/weixin/mywebchat/checkUser?weiboId=${acId}`,
        {
          method: "GET",
        },
      );
      if (err) {
        return err;
      }
      this.tb_bind = data.data.tbBind ? true : false;
      this.autoBind = data.data.autoBind;
      localStorage.setItem("UserCreateTime", data.data.createTime);
    }
  };
  //首页热销榜：每次进入首页向 Java 读取两榜，缓存更新由后端负责。
  stuffLoading = false;
  stuffCategoryId: any = "0";
  stuffCategoryList: any = [];
  stuffList: any = [];
  getStuffList = async () => {
    if (this.stuffLoading) return;
    this.stuffLoading = true;
    try {
      const response: any = await request(`/home/rank/list`, {
        method: "GET",
      });
      if (!response?.data || response.err) return;
      const groups = response.data.data;
      if (!Array.isArray(groups)) return;
      const selectedRankType = this.stuffList[this.stuffCategoryId]?.rankType;
      const list = [
        { rankType: "daily", typeName: "全天热销" },
        { rankType: "realtime", typeName: "实时热销" },
      ].map((group) => {
        const data = groups.find((item: any) => item.rankType === group.rankType);
        return {
          ...data,
          ...group,
          goodsInfoList: Array.isArray(data?.goodsInfoList) ? data.goodsInfoList : [],
        };
      });
      const selectedIndex = list.findIndex((item) => item.rankType === selectedRankType);
      this.stuffCategoryId = String(Math.max(selectedIndex, 0));
      this.stuffCategoryList = list.map((item, index) => ({
        type: String(index),
        val: item.typeName,
      }));
      this.stuffList = list;
    } catch (error) {
      Toast.show("榜单加载失败，请稍后重试");
    } finally {
      this.stuffLoading = false;
    }
  };
  //签到模块
  signConfig = [];
  GetIntegralConfig = async () => {
    if (this.signConfig.length > 0) return;
    const { data, err }: any = await request(`/integral/config`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
    this.signConfig = data.data;
  };
  //任务列表
  //任务列表
  taskList = [];
  processInfo: any = {
    newtask: 0,
    daytask: 0,
  };
  GetIntegralTask = async () => {
    const { data, err }: any = await request(`/integral/queryTask`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
    let newtask = 0,
      newtasklen = 0,
      daytask = 0,
      daytasklen = 0;
    const taskList = data.data.map((item: any) => {
      const moredata = getLogo(item.taskId);
      if (item.type == 0) {
        if (item.status == 0) {
          newtasklen += 1;
        }
      } else {
        daytasklen += 1;
        if (item.status == 1) {
          daytask += 1;
        }
      }
      return { ...item, ...moredata };
    });
    this.processInfo = {
      newtask: newtask + daytask,
      daytask: newtasklen + daytasklen,
    };
    this.taskList = taskList;
  };
  //获取签到情况
  signInfo = {};
  GetIntegralQuerySign = async () => {
    const { data, err }: any = await request(`/integral/querySign`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
    this.signInfo = data.data;
  };
  //签到
  GetIntegralSign = async () => {
    const { data, err }: any = await request(`/integral/sign`, {
      method: "GET",
    });
    if (err) {
      return;
    }
    SignPop.showSignIn(1, data.data);
    this.GetIntegralConfig();
    this.GetIntegralTask();
    this.GetIntegralQuerySign();
  };
  //淘宝自动授权开关integral/autoBind
  GetIntegralAutoBind = async () => {
    const acId = await getAcId();
    if (acId) {
      const { data, err }: any = await request(`/integral/autoBind`, {
        method: "GET",
      });
      if (err) {
        return err;
      }
      this.autoBind = true;
    }
  };
  //发送验证码
  sendCodeLoading = false;
  sendCode = async (phone: any, callBack: any) => {
    if (!/^1[3456789]\d{9}$/.test(phone)) {
      Toast.show("请输入正确的手机号！");
      return false;
    }
    if (this.sendCodeLoading) return;
    this.sendCodeLoading = true;
    const { data, err }: any = await request(
      `/common/sendCode?phone=${phone}`,
      {
        method: "GET",
      },
    );
    this.sendCodeLoading = false;
    if (err) {
      return false;
    }
    Toast.show("发送验证码成功！");
    callBack();
  };
  bindPhoneLoading = false;
  bindPhone = async (params: any) => {
    if (!/^1[3456789]\d{9}$/.test(params.phone)) {
      Toast.show("请输入正确的手机号！");
      return false;
    }
    if (params.code.length != 4) {
      Toast.show("请输入正确的验证码！");
      return false;
    }
    if (this.bindPhoneLoading) return;
    this.bindPhoneLoading = true;
    const { data, err }: any = await request(`/user/bindPhone`, {
      method: "POST",
      data: params,
    });
    this.bindPhoneLoading = false;
    if (err) {
      return false;
    }
    Toast.show("绑定手机号成功！");
    history.back();
  };
  //获取用户信息
  userInfo: any = {};
  GetuserInfo = async () => {
    const { data, err }: any = await request(`/user/info`, {
      method: "GET",
    });
    if (err) {
      return false;
    }
    this.userInfo = data.data;
  };
  //意见反馈
  feedImgs = [];
  feedLoading = false;
  postUserFeedBack = async (params: any) => {
    if (this.feedLoading) return;
    this.feedLoading = true;
    let imgUrlList = this.feedImgs.map((item: any) => {
      return item.url;
    });
    params.imgUrlList = imgUrlList;
    const { err }: any = await request(`/user/feedback`, {
      method: "POST",
      data: params,
    });
    if (err) {
      this.feedLoading = false;
      Toast.show("提交失败！");
      return;
    }
    Toast.show("提交成功！");
    setTimeout(() => {
      this.feedLoading = false;
      window.history.back();
    }, 1000);
  };
  // 系统通知
  SystemNotifyList = [];
  SystemNotifyListLoading = false;
  GetQuerySystemNotify = async () => {
    if (this.SystemNotifyListLoading) return;
    this.SystemNotifyListLoading = true;
    const { data, err }: any = await request(`/user/querySystemNotify`, {
      method: "GET",
    });
    this.SystemNotifyListLoading = false;
    if (err) {
      return false;
    }
    this.SystemNotifyList = data.data;
  };
  // 降价消息
  ReducePriceNotifyList = [];
  ReducePriceNotifyListLoading = false;
  GetReducePriceNotifyList = async () => {
    if (this.ReducePriceNotifyListLoading) return;
    this.ReducePriceNotifyListLoading = true;
    const { data, err }: any = await request(`/user/reducePriceNotify`, {
      method: "GET",
    });
    this.ReducePriceNotifyListLoading = false;
    if (err) {
      this.ReducePriceNotifyList = [];
      return false;
    }
    this.ReducePriceNotifyList = data.data;
  };
  //0元兑换
  GoodsIntegralCategory = [];
  GetGoodsIntegralCategory = async () => {
    const { data, err }: any = await request(`/goods/integral/category`, {
      method: "GET",
    });
    if (err) return;
    this.GoodsIntegralCategory = data.data;
    return data.data;
  };
  IntegralInfoCategoryId: any = "";
  IntegralInfoPage: any = 1;
  postGoodsIntegralInfoListHasMore = true;
  postGoodsIntegralInfoListLoading = false;
  postGoodsIntegralInfoList: any = [];
  postGoodsIntegralInfo = async () => {
    if (this.postGoodsIntegralInfoListLoading) return;
    if (!this.postGoodsIntegralInfoListHasMore) return;
    this.postGoodsIntegralInfoListLoading = true;
    const lastparams = {
      categoryId: this.IntegralInfoCategoryId,
      pageNum: this.IntegralInfoPage,
      pageSize: 20,
    };
    const { data, err }: any = await request(`/goods/integral/info`, {
      method: "POST",
      data: lastparams,
    });
    this.postGoodsIntegralInfoListLoading = false;
    if (err) {
      return;
    }
    const list = data.data.list || [];
    if (lastparams.pageNum == 1) {
      this.postGoodsIntegralInfoList = [...list];
    } else {
      this.postGoodsIntegralInfoList = [
        ...this.postGoodsIntegralInfoList,
        ...list,
      ];
    }
    if (list.length < 20) {
      this.postGoodsIntegralInfoListHasMore = false;
    } else {
      this.IntegralInfoPage = this.IntegralInfoPage + 1;
    }
  };
  //积分兑换
  integralItem: any = null;
  // 积分兑换
  transformMemberPointLoding = false;
  transformMemberPointInfo = {};
  transformMemberPoint = async () => {
    if (this.transformMemberPointLoding) return;
    this.transformMemberPointLoding = true;
    NProgress.set(0.6);
    const search = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(`/user/integral/goods/exchange`, {
      method: "POST",
      data: {
        productId: search.get("itemId"),
        categoryId: search.get("categoryId"),
      },
    });
    this.transformMemberPointLoding = false;
    if (err) {
      NProgress.set(1);
      return;
    }
    if (isWeiXinAndQQ()) {
      //微信和QQ淘宝品口令购买
      TokenPopup.showToken(1, data.data.token);
      NProgress.set(1);
      return;
    }
    if (isWeiBo()) {
      let visible = true;
      let timeout: any = null;
      let startTime = 0;
      const handle = () => {
        if (document.visibilityState === "hidden") {
          startTime = new Date().getTime();
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          visible = false;
        }
        if (document.visibilityState === "visible") {
          document.removeEventListener("visibilitychange", handle);
          if (new Date().getTime() - startTime < 300 && isAndroid()) {
            window.location.href = data.data.link;
          }
          visible = false;
        }
      };
      document.addEventListener("visibilitychange", handle);
      const iframe: any = document.createElement("iframe");
      iframe.style.visibility = "hidden";
      iframe.style.width = 0;
      iframe.style.height = 0;
      iframe.src = data.data.urlScheme;
      iframe.onerror = () => (window.location.href = data.data.link);
      document.body.appendChild(iframe);
      timeout = setTimeout(() => {
        if (visible) window.location.href = data.data.link;
      }, 2000);
      setTimeout(() => {
        NProgress.set(1);
      }, 2000);
      return;
    }
    NProgress.set(1);
    window.location.href = data.data.link;
  };
  // 浏览记录/user/productBrowse
  browseList = [];
  browseListLoading = false;
  browseListAllFlag = false;
  GetBrowseList = async () => {
    if (this.browseListLoading) return;
    this.browseListLoading = true;
    const { data, err }: any = await request(`/user/productBrowse`, {
      method: "GET",
    });
    this.browseListLoading = false;
    if (err) {
      return false;
    }
    const list = data.data.map((item: any) => {
      item.selectflag = false;
      item.createtime = item.browseTime.split(" ")[0];
      return item;
    });
    let newArr: any = [];
    list.forEach((item: any) => {
      let index = -1;
      let isExists = newArr.some((newItem: any, j: number) => {
        if (item.createtime == newItem.createtime) {
          index = j;
          return true;
        }
      });
      if (!isExists) {
        newArr.push({
          createtime: item.createtime,
          subList: [item],
        });
      } else {
        newArr[index].subList.push(item);
      }
    });
    console.log(newArr, "---");
    this.browseList = newArr;
  };
  //删除浏览记录
  CancleProductBrowseLoading = false;
  PostCancleProductBrowse = async (params: any, callBack = () => {}) => {
    if (this.CancleProductBrowseLoading) return;
    this.CancleProductBrowseLoading = true;
    let productBrowseIds = "";
    if (this.browseListAllFlag) {
      productBrowseIds = "0";
    } else {
      productBrowseIds = params.itemIds.join(",");
    }
    const { data, err }: any = await request(
      `/user/productBrowse/del?productBrowseIds=${productBrowseIds}`,
      {
        method: "GET",
      },
    );
    this.CancleProductBrowseLoading = false;
    if (err) {
      return;
    }
    this.GetBrowseList();
    if (callBack) {
      callBack();
    }
    Toast.show("删除浏览记录成功了");
  };
  //兑换记录
  IntegralCollect = {};
  GetIntegralCollect = async () => {
    const { data, err }: any = await request(`/user/integral/collect`, {
      method: "GET",
    });
    if (err) return;
    this.IntegralCollect = data.data;
  };
  //获取兑换记录列表
  IntegralRecord = [];
  IntegralRecordLoading = false;
  GetIntegralRecord = async (status: any) => {
    if (this.IntegralRecordLoading) return;
    this.IntegralRecordLoading = true;
    const { data, err }: any = await request(
      `/user/integral/record/${status}`,
      {
        method: "GET",
      },
    );
    if (err) {
      this.IntegralRecordLoading = false;
      return;
    }
    this.IntegralRecord = data.data;
    this.IntegralRecordLoading = false;
  };
  jumpTaoBao = async (data: any) => {
    if (isWeiXinAndQQ() && this.productDetail.platform == "tb" && data.token) {
      //微信和QQ淘宝品口令购买
      TokenPopup.showToken(1, data.token);
      NProgress.set(1);
      return;
    }
    if (isWeiBo()) {
      let visible = true;
      let timeout: any = null;
      let startTime = 0;
      const handle = () => {
        if (document.visibilityState === "hidden") {
          startTime = new Date().getTime();
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          visible = false;
        }
        if (document.visibilityState === "visible") {
          document.removeEventListener("visibilitychange", handle);
          if (new Date().getTime() - startTime < 300 && isAndroid()) {
            window.location.href = data.link;
          }
          visible = false;
        }
      };
      document.addEventListener("visibilitychange", handle);
      const iframe: any = document.createElement("iframe");
      iframe.style.visibility = "hidden";
      iframe.style.width = 0;
      iframe.style.height = 0;
      iframe.src = data.urlScheme;
      iframe.onerror = () => (window.location.href = data.link);
      document.body.appendChild(iframe);
      timeout = setTimeout(() => {
        if (visible) window.location.href = data.link;
      }, 2000);
      setTimeout(() => {
        NProgress.set(1);
      }, 2000);
      return;
    }
    NProgress.set(1);
    window.location.href = data.link;
  };
  //淘宝授权
  tbGoodsInfo: any = {};
  getTbAuthorizeGoods = async () => {
    if (this.tb_bind) {
      return;
    }
    const { data, err }: any = await request(`/user/tb/authorize/goods`, {
      method: "GET",
    });
    this.tbGoodsInfo = data.data;
  };
  UserTbAuthorize = async () => {
    if (this.tb_bind) {
      return;
    }
    const { data, err }: any = await request(`/user/tb/authorize`, {
      method: "GET",
    });
    this.jumpTaoBao(data.data);
  };
  //逛逛社区
  searchVisitKeywords = "";
  searchVisitInputFocusFlag = false;
  searchVisitInputChange = async (e: any) => {
    const text = trim(e.target.value);
    this.searchVisitKeywords = text;
    if (!text || text.length === 0) {
      this.searchVisitKeywords = "";
      this.WeiboArticleQueryArticle(this.WeiboArticleCategoryId);
    }
  };
  searchVisitList: any = {};
  searchVisitListLoading = false;
  searchVisit = async (e: any) => {
    if (this.searchVisitListLoading) return;
    if (this.keywords && this.keywords?.length < 2) {
      return;
    }
    if (this.searchVisitKeywords == this.keywords) {
      return;
    }
    this.searchVisitList = {};
    this.searchVisitKeywords = this.keywords;
    this.searchVisitListLoading = true;
    const { data, err }: any = await request(
      `/api/weiboArticle/search?text=${this.keywords}`,
      {
        method: "GET",
      },
    );
    this.searchVisitListLoading = false;
    if (err) {
      return;
    }
    this.searchVisitList = data.data;
  };
  //查询页面配置
  WeiboArticleQueryConfigInfo: any = {};
  WeiboArticleCategoryId = "";
  WeiboArticleQueryConfig = async () => {
    let scence = 1;
    const params = new URLSearchParams(window.location.search);
    if (params.get("scence") === "landing") {
      const startTime = new Date("2023/11/11 19:40:00").getTime();
      const endTime = new Date("2023/11/11 20:40:00").getTime();
      const nowTime = new Date().getTime();
      if (nowTime > startTime && nowTime < endTime) {
        this.WeiboArticleQueryConfigInfo = {
          id: 2,
          scence: "2",
          adminCategoryConfigDtoList: [
            {
              categoryId: "1",
              categoryName: "#发现每日好物",
              type: 1,
              url: "",
            },
          ],
          customName: "好文好物搬运官",
          customImg:
            "https://cdn.mlj36.com/d11admin/img/cffef3b6-8650-4e5c-8ff6-d79a54a8057d.png",
          desc: "发现好物转载！",
        };
        this.WeiboArticleCategoryId = "1";
        this.WeiboArticleQueryArticleList = [
          {
            id: 508296,
            mid: "4966654134191432",
            ghId: "6591117971",
            weiboName: "安利菌",
            text: "👍 抽一个宝儿送免单💰 <br /><br />【39】立白 茶籽洗衣液12斤，有红包到手更低‼️ <br /> 这个很好用！好好闻好香好香 ！大促必囤😍<br /><br />直接拍： ",
            picIds:
              "https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjqd8s1rvzj30f60kagns.jpg,https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjqd8sr09ej30j60oumzl.jpg",
            type: 1,
            categoryId: 1,
            itemId: "Kq9YYqJt3toMdx7ynnFmVMIJt7-GKGOWR8crd0B9kOjCnj",
            title: "立白家用洗衣液整箱批12斤茶籽除菌除螨6KG 香味持久",
            platform: "tb",
            itemSource: "公司top",
            couponId: "dbfdbf9321354064bbe35be15add4caf",
            couponAmount: 20,
            price: 179,
            couponStartTime: "2023-11-10 00:00:00",
            couponEndTime: "2023-11-13 23:59:59",
            commission: 5.99,
            sort: 9,
            status: 1,
            top: "2",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-10 22:21:24",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
          {
            id: 508297,
            mid: "4966933025264041",
            ghId: "6412548107",
            weiboName: "海淘大牌",
            text: "【评论抽1个宝52！！】<br /><br /> 兰芝 小蓝盾水乳套装💥114<br /> 兰芝 小蓝盾水乳套装💥114<br /><br /> 全网史低！！！！它是品牌38年研究的好吸收微分子，可以细腻毛孔+维稳肌肤，主要这个价格还是兰芝诶！！！拿来补补水都香啊 ",
            picIds:
              "https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9anj71oj30j60j676f.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9aq09q5j30j60oa76c.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9aqqo72j30j60phgo2.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9arerixj30j60jaq48.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9as0z4pj30j60jaq48.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9asq315j30j60jaq48.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9atnpchj30j60mpn0k.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9av9wt0j30j60phq54.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr9aw6cvgj30j60pn786.jpg",
            type: 1,
            categoryId: 1,
            itemId: "nJJ0eWkIMt3MNAyRb7hky0U0tP-k3edXK7sgnKJMroQC5a",
            title:
              "【双11现货】兰芝新水酷水乳水衡护肤套装小蓝盾补水保湿维稳滋润",
            platform: "tb",
            itemSource: "公司top",
            couponId: "4f4602352ff54d2094304900d19452fd",
            couponAmount: 146,
            price: 189,
            couponStartTime: "2023-11-10 20:00:00",
            couponEndTime: "2023-11-11 23:59:59",
            commission: 41.72,
            sort: 10,
            status: 1,
            top: "2",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-11 16:49:37",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
          {
            id: 508298,
            mid: "4966896760000797",
            ghId: "6412548107",
            weiboName: "海淘大牌",
            text: "随时停❗️ 19.9💥薇诺娜舒敏修护精华液10ml！ ",
            picIds:
              "https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr50w14srj30j60oidob.jpg",
            type: 1,
            categoryId: 1,
            itemId: "pBXJ4kAHxt6R8Y0OBKIe39hptm-jGwQkK5TXXe7kjBkSzK",
            title: "薇诺娜舒敏保湿修护精华液10ml24年8月到期舒缓敏感修护肌肤",
            platform: "tb",
            itemSource: "公司top",
            couponId: "87b1ba6dae0d48ab9674d66741a1fecb",
            couponAmount: 196,
            price: 104.9,
            couponStartTime: "2023-11-10 20:00:00",
            couponEndTime: "2023-11-11 23:59:59",
            commission: 97.49,
            sort: 11,
            status: 1,
            top: "1",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-11 14:25:31",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
          {
            id: 508299,
            mid: "4966947022440099",
            ghId: "6591117971",
            weiboName: "安利菌",
            text: "🔥科丽尼 头皮素30ml【19.9】<br />🔥科丽尼 头皮素30ml【19.9】<br /><br />科丽尼头皮素正装的确不便宜，安仔推荐先买30或60ml来试一下，用了觉得适合自己再来回购正装，这个羊毛不要错过哈！ ",
            picIds:
              "https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjrb2mx1s9j30j60yejwb.jpg,https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjqwzufwu2j30j60ot42v.jpg,https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjqx2tmoftj30j60p077q.jpg,https://weiboimage.mlj36.com/mw2000/007c3ESngy1hjrb2nxfhtj30j60p6n1h.jpg",
            type: 1,
            categoryId: 1,
            itemId: "DMzY6mYHDt5bze84RptQw2Cjtn-jGwQkK5TXKNb8oWJTzz",
            title: "【双11】科丽尼头皮素敏感修护去屑控油蓬松毛囊洗发水露洗头膏",
            platform: "tb",
            itemSource: "公司top",
            couponId: "035b6a81428945b7a5ec7cf62121f15f",
            couponAmount: 231,
            price: 69.9,
            couponStartTime: "2023-11-11 00:00:00",
            couponEndTime: "2023-11-11 23:59:59",
            commission: 62.4,
            sort: 12,
            status: 1,
            top: "1",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-11 17:45:14",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
          {
            id: 508301,
            mid: "4966889618148300",
            ghId: "6412548107",
            weiboName: "海淘大牌",
            text: "妈呀 这个划算💥 好便宜！好便宜！！<br /><br />25一箱的人养一头牛纯牛奶❗️ 我直接啊啊啊啊啊 ！这可是纯牛奶啊 ",
            picIds:
              "https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr4dk9yrxj30k40b83zk.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr4dl3uuzj30t00yaju1.jpg",
            type: 1,
            categoryId: 1,
            itemId: "g0Zy270t3t2Re0VBA2Fo3MTatr-bXG76geHGXrbaGA8iZb",
            title:
              "【渠道推荐】认养一头牛常温酸奶200mL*10盒*3箱官方补贴限量抢购",
            platform: "tb",
            itemSource: "公司top",
            couponId: "3c4e30cd92754515a17b80cb201163b1",
            couponAmount: 20,
            price: 89.9,
            couponStartTime: "2023-11-10 20:00:00",
            couponEndTime: "2023-11-12 23:59:59",
            commission: 8,
            sort: 14,
            status: 1,
            top: "1",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-11 13:57:08",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
          {
            id: 508302,
            mid: "4966909166488927",
            ghId: "6412548107",
            weiboName: "海淘大牌",
            text: '卧槽卧槽！骆驼漏🕳️！随时结束<span class="url-icon"><img alt=[抓狂] src="https://h5.sinaimg.cn/m/emoticon/icon/default/d_zhuakuang-c007ffb7fe.png" style="width:1em; height:1em;" /></span><br />——赞+评，抽5位公主平分50大洋！！<br /><br />骆驼 加绒登山服【💥173】<br />骆驼 加绒登山服【💥173】<br /><br />日常要699的啊<span class="url-icon"><img alt=[抓狂] src="https://h5.sinaimg.cn/m/emoticon/icon/default/d_zhuakuang-c007ffb7fe.png" style="width:1em; height:1em;" /></span>明天就恢复原价❗️ ',
            picIds:
              "https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p5pgepj30f00uin1j.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p6hdraj30eo0qsjtr.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p7a7njj30ki0i3q4u.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p89yb4j30j60on40q.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p94yi5j30j60pjwg7.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6p9xsbgj30j60oq40z.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6palrj6j30j60j2ad3.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6pbasb8j30j60j277d.jpg,https://weiboimage.mlj36.com/mw2000/006ZYoHhgy1hjr6pc2pwqj30j60j0gol.jpg",
            type: 1,
            categoryId: 1,
            itemId: "nbZGG3PfMt3MN7Bnn2UkQBt0tP-5n4WgaoHWGjB4G2Wu4",
            title:
              "骆驼运动外套男女款登山服2023春秋防风防水连帽户外休闲夹克风衣",
            platform: "tb",
            itemSource: "公司top",
            couponId: "808fea3bdeb04e7fa80d6e37bf387a1e",
            couponAmount: 400,
            price: 299,
            couponStartTime: "2023-11-10 20:00:00",
            couponEndTime: "2023-11-11 23:59:59",
            commission: 61.36,
            sort: 15,
            status: 1,
            top: "1",
            commissionAll: null,
            automatic: 1,
            createTime: "2023-11-11 15:14:49",
            itemUrl: null,
            headlines: "1",
            orders: null,
          },
        ];
        return false;
      }
      scence = 2;
    }
    const { data, err }: any = await request(
      `/api/weiboArticle/queryConfig?scence=${scence}`,
      {
        method: "GET",
      },
    );
    if (err) {
      return;
    }
    this.WeiboArticleQueryArticle(
      data.data?.adminCategoryConfigDtoList[0]?.categoryId,
    );
    this.WeiboArticleQueryConfigInfo = data.data;
  };
  //查询数据liebiao
  WeiboArticleQueryArticleList: any = [];
  WeiboArticleQueryArticleLoading = false;
  WeiBoVisit: any = {};
  WeiboArticleQueryArticle = async (categoryId: any) => {
    this.searchVisitKeywords = "";
    if (this.WeiboArticleQueryArticleLoading) return;
    if (!categoryId) return;
    if (this.WeiboArticleCategoryId != categoryId) {
      this.WeiboArticleQueryArticleList = [];
    }
    window.scrollTo(0, 0);
    this.WeiboArticleCategoryId = categoryId;
    this.WeiboArticleQueryArticleLoading = true;
    const { data, err }: any = await request(
      `/api/weiboArticle/queryArticle?categoryId=${this.WeiboArticleCategoryId}`,
      {
        method: "GET",
      },
    );
    this.WeiboArticleQueryArticleLoading = false;
    if (err) {
      return;
    }
    let topList: any = [];
    let lastList: any = [];
    const ids = this.WeiBoVisit?.ids || [];
    if (ids?.length > 0) {
      data.data.map((item: any) => {
        if (ids.indexOf(item.id) != -1) {
          topList.push(item);
        } else {
          lastList.push(item);
        }
      });
    } else {
      lastList = data.data;
    }
    this.WeiBoVisit = {};
    this.WeiboArticleQueryArticleList = [...topList, ...lastList];
  };
  //直播预告页面
  searchKeywords = "";
  scene = "lijiaqi";
  todayCategoryId = "";
  searchCategoryList: any = [];
  searchInputChange = async (e: any) => {
    const text = trim(e.target.value);
    this.searchKeywords = text;
    if (!text || text.length === 0) {
      this.searchKeywords = "";
    }
  };
  //获取商品列表
  liveLoading = false;
  firstLoading = false;
  liveList: any = [];
  pageScrollY = 0;
  liveScrollFlag = true;
  liveHasMore = true;
  liveFlatFlag = false;
  livePage = 1;
  liveSearchFlag = false;
  requestFirst = true;
  getLiveList = async () => {
    if (this.liveLoading) return;
    if (!this.liveHasMore) return;
    this.liveFlatFlag =
      this.scene == "live" || this.liveSearchFlag ? true : false;
    let linkUrl =
      this.scene == "live"
        ? `/live-goods/check-price?scene=${this.scene}&page_size=50&page=${this.livePage}`
        : `/live-goods/today-list?scene=${this.scene}`;
    if (this.liveSearchFlag && this.searchKeywords) {
      linkUrl = linkUrl + `&keyword=${this.searchKeywords}`;
    }
    if (isWeiXinAndQQ()) {
      linkUrl = linkUrl + `&platform=shequn`;
    }
    this.liveLoading = true;
    this.firstLoading = true;
    const { data, err }: any = await lvieRequest(linkUrl, {
      method: "GET",
      data: {},
    });
    if (err) {
      return;
    }
    this.liveLoading = false;
    if (this.requestFirst && this.scene == "lijiaqi" && data.data.length == 0) {
      this.scene = "girls";
      this.requestFirst = false;
      this.getLiveList();
      return;
    } else {
      this.requestFirst = false;
    }
    if (this.scene != "live") {
      if (this.liveSearchFlag) {
        this.searchCategoryList = [
          {
            category_id: "all",
            category_name: "全部",
          },
          {
            category_id: "back",
            category_name: "返回列表",
          },
        ];
        this.todayCategoryId = "all";
        let list = data.data || [];
        let flList: any = [];
        list.map((item: any) => {
          flList = [...flList, ...item.list];
        });
        this.liveList = flList;
      } else {
        let list = data.data || [];
        let flList: any = [];
        list.map((item: any) => {
          flList.push({
            category_id: item.category_id.toString(),
            category_name: item.category_name,
          });
        });
        this.todayCategoryId = flList[0]?.category_id || "";
        this.searchCategoryList = flList;
        this.liveList = list;
      }
    } else {
      let list = data.data.list || [];
      this.liveHasMore = data.data.hasMore;
      this.liveList = [...this.liveList, ...list];
      if (this.liveSearchFlag) {
        this.searchCategoryList = [
          {
            category_id: "all",
            category_name: "全部",
          },
          {
            category_id: "back",
            category_name: "返回列表",
          },
        ];
        this.todayCategoryId = "all";
      }
      this.livePage = this.livePage + 1;
    }
  };
  //查询直播价
  liveCopyText = "";
  hanleJumpLive = (data: any) => {
    const url_scheme =
      this.scene == "live" ? data.link_scheme : data.url_scheme;
    const link = this.scene == "live" ? data.link : data.url;
    const tao_token = this.scene == "live" ? data.tao_token : data.taotoken;
    Toast.clear();
    if (isWeiBo()) {
      //重新转链接
      this.productDetail = {
        itemId: data.item_id,
        platform: "tb",
        sortIndex: 0,
        sortFrom: "extension",
      };
      this.transformLink(5);
    } else if (isWeiXinAndQQ()) {
      this.liveCopyText = tao_token;
      Toast.show({
        content: "亲，口令复制成功啦，快打开淘宝抢购吧！",
        duration: 1500,
      });
    } else {
      this.productDetail = {
        itemId: data.item_id,
        platform: "tb",
        sortIndex: 0,
        sortFrom: "extension",
      };
      this.transformLink(5);
    }
  };
  //落地页参数
  recordPlatform: any = "";
  pddStatus: any = 0;
  recordImgUrl: any = "";
  recordUrl: any = "";
  postHomeBToken = async (params: any) => {
    const acId = await getAcId();
    if (acId) {
      await request(`/home/b/token`, {
        method: "POST",
        data: params,
      });
    }
  };
  postHomeGoodsRecord = async (params: any) => {
    const acId = await getAcId();
    if (acId) {
      await request(
        `/home/goods/record?platform=${params.platform}&itemId=${params.itemId}`,
        {
          method: "GET",
          data: params,
        },
      );
    }
  };
  //群接龙小程序
  JumpPro = async (data: any) => {
    if (isWeiBo()) {
      const path = `pro/pages/seq-detail/detail-mutual-sale-child/detail-mutual-sale-child?actId=${data.h}&inviteUid=${data.invite}`;
      const lasturl =
        "sinaweibo://wbdiversion?username=" +
        data.u +
        "&path=" +
        encodeURIComponent(path);
      console.log(lasturl, "---");
      window.location.href = lasturl;
      const apiDomain =
        "https://microservice-datacenter-backend-go.io.mlj162.com";
      const vuidStoreKey = "clicklink-vuid";
      let vuid = localStorage.getItem(vuidStoreKey);
      const payload = {
        type: "item",
        platform: "qjl",
        link: window.location.href,
        vuid: vuid || "",
        gh_id: data.gh_id,
        itemid: data.h,
        adzoneid: data.invite,
      };
      axios
        .post(apiDomain + "/clicklink/report", payload)
        .then((response) => {
          console.log("report response data", response.data);
          const respBody = response.data;
          if (vuid == null && Boolean(respBody.data.vuid)) {
            localStorage.setItem(vuidStoreKey, respBody.data.vuid);
          }
        })
        .catch((err) => {
          console.log("report err:", err);
        });
    } else {
      const res = await requestApi({
        url: "/wxa-link/gen_url_scheme",
        method: "POST",
        data: {
          appId: "wx974b793334f3667b",
          expireType: 1,
          expireInterval: 30,
          jumpWxa: {
            path: "pro/pages/seq-detail/detail-mutual-sale-child/detail-mutual-sale-child",
            query: `actId=${data.h}&inviteUid=${data.invite}&fromShare=1&shareByLink=1`,
          },
        },
      });
      window.location.href = res.data.openLink;
    }
  };
}
export default new store();
